// Select the target node that contains the displayed price
const targetNode = document.querySelector('[data-product-price]');

// Options for the observer (which mutations to observe)
const config = { childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback = function(mutationsList, observer) {
  for(const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      // Get the current displayed price
      const displayedPrice = parseFloat(targetNode.textContent.replace(/[^0-9.]/g, ''));

      // Check if the price is less than or equal to 50
      if (displayedPrice <= 200) {
        // Adjust the price by adding 1160
        const adjustedPrice = displayedPrice + 1160;

        // Format adjusted price with comma separator in Taiwan
var formattedPrice = adjustedPrice.toLocaleString('zh-TW');
        
        // Update the displayed price on the page
        targetNode.innerHTML = 'NT$' + formattedPrice + '起';
      }
    }
  }
};

// Create a new observer instance
const observer = new MutationObserver(callback);

// Start observing the target node for mutations
observer.observe(targetNode, config);